import { ChangeDetectorRef, Component, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OccProductSearchAdapter } from '@spartacus/core';
import { FacetComponent, FacetService } from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';
import { CategoryPageService } from 'src/app/customServices/category-page.service';
import { FormulaBlueService } from 'src/app/services/feature/Formula_blue/formula-blue.service';
import { ProductListService } from 'src/app/services/feature/product-list.service';
import { SteeringGearService } from 'src/app/services/feature/steeringGear/steering-gear.service';

@Component({
  selector: 'app-facet-kb',
  templateUrl: './facet-kb.component.html',
  styleUrls: ['./facet-kb.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FacetKbComponent extends FacetComponent {
  showContent: boolean;
  categoryCode: any;
  defaultPageSize: number = 20;
  initalPageNum: number = 0;
  @Input() facetTabName;
  model$: any;
  SteeringFormData: any;
  formulaFormData: any;
  searchQuery: any;

  private readonly destroy$ = new Subject<void>();

  constructor(
    facetService: FacetService,
    elementRef: ElementRef<HTMLElement>,
    private activatedRoute: ActivatedRoute,
    private productListService: ProductListService,
    public searchService: OccProductSearchAdapter,
    private CategoryService: CategoryPageService,
    private kbSteeringService: SteeringGearService,
    private formulaBlueService: FormulaBlueService,
    cd: ChangeDetectorRef
  ) {
    super(facetService, elementRef, cd);
  }
  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log("data", data);
      this.categoryCode = data?.['categoryCode'];
      this.searchQuery = data?.['query']
    })
  }
  FacetClick(e, FacetName) {
    const queryValue = this.productListService.DecodeQuery(e.query.query.value);

    if (FacetName === 2) {
      this.productListService.getDocumentDetails(this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          docModel: data,
        });
      })
    } else if (FacetName === 3) {
      this.productListService.getSoftwareDetails(this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          softwareModel: data,
        });
      })
    }
    else if (FacetName === 1) {
      this.productListService.getCrossRefDetails(this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          crossRefModel: data,
        });
      })
    }
    else if (FacetName === 0) {
      const pagination = {
        text: this.searchQuery
      }
      this.searchService.search(queryValue, pagination).pipe(takeUntil(this.destroy$)).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          productModel: data,
        });
      })
    }
    else if (FacetName === 6) {
      this.CategoryService.getCategoryPageData(this.categoryCode, queryValue, this.initalPageNum, this.defaultPageSize).pipe(takeUntil(this.destroy$)).subscribe();
    }
    else if (FacetName === 7) {
      const docQuery = this.productListService.getCustomDocQuery(e.query.query.value);
      this.productListService.getCustomDocumentDetails(docQuery, this.defaultPageSize, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.productListService.seperateDocDetails$.next(x);
      });
    }
    else if (FacetName === 8) {
      const softQuery = this.productListService.getCustomSoftwareQuery(e.query.query.value);
      this.productListService.getCustomSoftwareDetails(softQuery, this.defaultPageSize, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.productListService.seperateSoftDetails$.next(x);
      });
    }
    else if (FacetName === 9) {
      this.kbSteeringService.SteeringPayLoad$.pipe(takeUntil(this.destroy$)).subscribe(X => {
        this.SteeringFormData = X;
      });
      this.kbSteeringService.submitSteeringData(this.SteeringFormData, this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.productListService.SteeringProdDetails$.next(x?.['searchPageData']);
        this.cd.detectChanges();
      });
    }
    else if (FacetName === 10) {
      this.formulaBlueService.formulaBluePayLoad$.pipe(takeUntil(this.destroy$)).subscribe(X => {
        this.formulaFormData = X;
      });
      this.formulaBlueService.submitFormulaData(this.SteeringFormData, this.defaultPageSize, queryValue, this.initalPageNum).pipe(takeUntil(this.destroy$)).subscribe((x) => {
        this.productListService.FormulaProdDetails$.next(x?.['searchPageData']);
        this.cd.detectChanges();
      });
    }
  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}


